import SideMenu from './SideMenu.gql';

export default SideMenu;
